import axios from 'axios'

const authConfig = (access) => ({
  headers: { Authorization: `Bearer ${access}` },
})

// --------------------------- Anonymous public link ---------------------------

export const getDashboardSharing = (code, access) => (
  axios.get(`/api/v1/dashboard/${code}/sharing/`, authConfig(access)).then(response => response.data)
)

export const enableDashboardSharing = (code, access) => (
  axios({
    method: 'post',
    url: `/api/v1/dashboard/${code}/sharing/enable/`,
    ...authConfig(access),
  }).then(response => response.data)
)

export const regenerateDashboardSharing = (code, access) => (
  axios({
    method: 'post',
    url: `/api/v1/dashboard/${code}/sharing/regenerate/`,
    ...authConfig(access),
  }).then(response => response.data)
)

export const disableDashboardSharing = (code, access) => (
  axios({
    method: 'delete',
    url: `/api/v1/dashboard/${code}/sharing/`,
    ...authConfig(access),
  }).then(response => response.data)
)

// --------------------------- Invite links (editor/viewer access) ---------------------------

export const getShareLinks = (code, access) => (
  axios.get(`/api/v1/dashboard/${code}/share-links/`, authConfig(access)).then(response => response.data)
)

// body: { role, max_uses, expires_in_days } — see backend contract:
// omitting expires_in_days defaults to 30 days, explicit null means never.
export const createShareLink = (code, access, body) => (
  axios({
    method: 'post',
    url: `/api/v1/dashboard/${code}/share-links/`,
    data: body,
    ...authConfig(access),
  }).then(response => response.data)
)

export const revokeShareLink = (code, access, linkId) => (
  axios({
    method: 'delete',
    url: `/api/v1/dashboard/${code}/share-links/${linkId}/`,
    ...authConfig(access),
  }).then(response => response.data)
)

export const deleteShareLink = (code, access, linkId) => (
  axios({
    method: 'delete',
    url: `/api/v1/dashboard/${code}/share-links/${linkId}/delete/`,
    ...authConfig(access),
  }).then(response => response.data)
)

// --------------------------- Collaborators (people with access) ---------------------------

export const getCollaborators = (code, access) => (
  axios.get(`/api/v1/dashboard/${code}/collaborators/`, authConfig(access)).then(response => response.data)
)

export const updateCollaboratorRole = (code, access, collaboratorId, role) => (
  axios({
    method: 'patch',
    url: `/api/v1/dashboard/${code}/collaborators/${collaboratorId}/`,
    data: { role },
    ...authConfig(access),
  }).then(response => response.data)
)

export const removeCollaborator = (code, access, collaboratorId) => (
  axios({
    method: 'delete',
    url: `/api/v1/dashboard/${code}/collaborators/${collaboratorId}/`,
    ...authConfig(access),
  }).then(response => response.data)
)

export const removeAllCollaborators = (code, access) => (
  axios({
    method: 'post',
    url: `/api/v1/dashboard/${code}/collaborators/revoke-all/`,
    ...authConfig(access),
  }).then(response => response.data)
)

// --------------------------- Shared dashboards lists ---------------------------

export const getSharedWithMe = (access, page = 1) => (
  axios.get('/api/v1/dashboard/shared-with-me/', {
    ...authConfig(access),
    params: { page },
  }).then(response => response.data)
)

export const getSharedByMe = (access, page = 1) => (
  axios.get('/api/v1/dashboard/shared-by-me/', {
    ...authConfig(access),
    params: { page },
  }).then(response => response.data)
)
